const MuiMenuItem = {
  variants: [
    {
      props: { variant: 'navbarProductsItem' },
      style: ({ theme }) => ({
        width: '480px',
        height: '66px',
        padding: '12px 24px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        '&:hover': {
          backgroundColor: 'white',
          borderRight: `8px solid ${theme.palette.primary.A700}`,
          '& .MuiTypography-root:first-child': {
            color: theme.palette.primary.A700,
          },
        },
      }),
    },
    {
      props: { variant: 'entitiesListItem' },
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: '5rem',
        flexShrink: 0,
      },
    },
    {
      props: { variant: 'navbarProductsItemMobile' },
      style: {
        width: '100%',
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  ],
};

export default MuiMenuItem;
